import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../../components/header";
import HeaderMembro from "../../components/header3";
import Footer from "../../components/footer";
import AssociatedTime from "./associatedTime";
import AssociatedTime36 from "./associatedTime36";
import Heritage from "./heritage";
import Heritage60 from "./heritage60";
/* import Goal from './goal'; */
import GoalPercentage from "./goalPercentage";
import StatusTime from "./statusTime";
import Breadcrumbs from "../../components/breacrumbs";
import BackButton from "../../components/backButton";
import {
  ChartSkeleton,
  ProgressChartSkeleton,
  TallChartSkeleton,
} from "../../components/skeleton";
import Papa from "papaparse";
import { parseISO, differenceInDays, startOfDay, format } from "date-fns";
import { ptBR } from 'date-fns/locale';

const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  return !!token; // Retorna true se o token existir
};

const PageChart = () => {
  const navigate = useNavigate();
  const [authentication] = useState(isAuthenticated());
  const [chartsLoading, setChartsLoading] = useState(true);
  const [relativeDate, setRelativeDate] = useState("Carregando...");
  const [lastUpdate, setLastUpdate] = useState([]);

  useEffect(() => {
    // Verifica se o usuário está autenticado
    if (!authentication) {
      navigate("/login"); // Redireciona para a tela de login se não autenticado
    } else {
      // Busca os dados da planilha para calcular a data relativa
      const Url3 = process.env.REACT_APP_SHEET_3_URL;

      fetch(Url3)
        .then((response) => response.text())
        .then((data) => {
          // Parse o CSV para um array de objetos
          const parsedData = Papa.parse(data, { header: false }).data;
          // Extraia a data da segunda coluna da primeira linha
          const dataAtualizacao = parsedData[0][1];
          // Corrige a data para evitar problemas de fuso horário
          const date = parseISO(dataAtualizacao);

          // Ajusta as datas para o início do dia
          const todayStart = startOfDay(new Date());
          const dateStart = startOfDay(date);

          // Formata a data para o formato por extenso
          const formattedDate = format(
            date,
            "dd 'de' MMMM 'de' yyyy 'às' HH:mm'h'.",
            { locale: ptBR }
          );
          setLastUpdate(formattedDate);

          // Calcula a diferença em dias
          const differenceDays = differenceInDays(todayStart, dateStart);

          // Define a exibição relativa
          let calculatedRelativeDate;
          if (differenceDays === 0) {
            calculatedRelativeDate = "Atualizado hoje.";
          } else if (differenceDays === 1) {
            calculatedRelativeDate = "Atualizado ontem.";
          } else {
            calculatedRelativeDate = `Atualizado há ${differenceDays} dias.`;
          }
          setRelativeDate(calculatedRelativeDate);
        })
        .catch((error) => {
          console.error("Erro ao carregar o CSV:", error);
          setRelativeDate("Erro ao carregar dados.");
        });

      // Timer para o skeleton - aumentado para dar tempo dos gráficos carregarem
      const timer = setTimeout(() => {
        setChartsLoading(false);
      }, 3000); // 3 segundos para garantir que os dados dos gráficos tenham tempo de carregar

      return () => clearTimeout(timer);
    }
  }, [authentication, navigate]);

  return (
    <div>
      <Header></Header>
      <HeaderMembro></HeaderMembro>

      <div className="container chartLocationOnPage initialMargin">
        <div className="container d-flex align-items-center justify-content-between mt-3 mb-1">
          <BackButton toFallback="/home" />
          <Breadcrumbs />
        </div>

        <div className="charts-title-minimal">
          <h2>FUNDO SEM DESTINO</h2>
          <p className="charts-count">{relativeDate}<br></br>{lastUpdate}</p>
        </div>

        {chartsLoading ? (
          <>
            <div className="container-fluid chartLocationOnPage">
              <ProgressChartSkeleton />
            </div>
            <div className="container-fluid chartHeight chartLocationOnPage">
              <ChartSkeleton />
            </div>
            <div className="container-fluid chartHeight chartLocationOnPage">
              <ChartSkeleton />
            </div>
            <div className="container-fluid chartHeight chartLocationOnPage">
              <ChartSkeleton />
            </div>
            <div className="container-fluid chartHeight chartLocationOnPage">
              <ChartSkeleton />
            </div>
            <div className="container-fluid chartLocationOnPage1">
              <TallChartSkeleton />
            </div>
          </>
        ) : (
          <>
            <div className="container-fluid chartLocationOnPage">
              <GoalPercentage></GoalPercentage>
            </div>
            <div className="container-fluid chartHeight chartLocationOnPage">
              <Heritage60></Heritage60>
            </div>
            <div className="container-fluid chartHeight chartLocationOnPage">
              <Heritage></Heritage>
            </div>
            <div className="container-fluid chartHeight chartLocationOnPage">
              <AssociatedTime36></AssociatedTime36>
            </div>
            <div className="container-fluid chartHeight chartLocationOnPage">
              <AssociatedTime></AssociatedTime>
            </div>
            <div className="container-fluid chartLocationOnPage1">
              <StatusTime></StatusTime>
            </div>
          </>
        )}
      </div>
      <Footer></Footer>
    </div>
  );
};

export default PageChart;
